class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dropdownTrigger = this.querySelector('.header-dropdown-trigger');
    this.dropdown = this.querySelector('header-dropdown');
    this.menuToggle = this.querySelector('.header-menu-toggle');
    this.mobileMenu = this.querySelector('.mobile-menu');
    this.headerTitle = this.querySelector('.header__title');

    if (document.body.classList.contains('template-index')) {
      // add color from hero
      const firstHero = this.closest('.shopify-section').nextElementSibling;
      const firstHeroColorScheme = Array.from(firstHero.querySelector('.media-pagination').classList).find((element) => element.startsWith('color-scheme'));
      if (firstHeroColorScheme) {
        this.classList.add(firstHeroColorScheme)
      }
      this.classList.remove('opacity-0');

      // check when scrolled past top
      const checkScroll = () => {
        if (window.scrollY == 0) {
          this.headerTitle.classList.remove('scrolled-past-top');
        } else {
          this.headerTitle.classList.add('scrolled-past-top');
        }
      }
      checkScroll();
      window.addEventListener('scroll', checkScroll);

      // check when scrolled past hero
      const options = {
        rootMargin: `-48px 0px 0px 0px`,
      };
      const intersectionObserver = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.classList.remove('scrolled-past-hero');
          } else {
            this.classList.add('scrolled-past-hero');
          }
        }
      }, options);
      intersectionObserver.observe(firstHero);
    }

    this.dropdownTrigger?.addEventListener('mouseenter', this.handleHover.bind(this));
    this.addEventListener('mouseleave', this.handleHoverOut.bind(this));
    this.menuToggle?.addEventListener('click', this.handleClick.bind(this));
  }

  handleHover() {
    this.dropdown?.classList.add('active');
  }

  handleHoverOut() {
    this.dropdown?.classList.remove('active');
  }

  handleClick() {
    if (this.mobileMenu?.classList.contains('active')) {
      this.mobileMenu?.classList.remove('active');
      this.menuToggle?.setAttribute('aria-expanded', 'false');
      this.menuToggle.textContent = 'Menu';
    } else {
      this.mobileMenu?.classList.add('active');
      this.menuToggle?.setAttribute('aria-expanded', 'true');
      this.menuToggle.textContent = 'Close';
    }
  }
}

customElements.define('header-drawer', HeaderDrawer);

class HeaderDropdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.collectionTitles = this.querySelectorAll('.header-links__collection-title');
    this.collections = this.querySelectorAll('header-featured-collection');

    this.collectionTitles.forEach(ele => ele.addEventListener('mouseenter', this.handleHover.bind(this)));
  }

  handleHover(event) {
    const index = event.currentTarget.dataset.index;

    this.collectionTitles.forEach(ele => ele.classList.remove('active'));
    event.currentTarget.classList.add('active');

    this.collections.forEach(ele => ele.classList.remove('active'));
    this.querySelector(`header-featured-collection[data-index="${index}"]`).classList.add('active');
  }
}

customElements.define('header-dropdown', HeaderDropdown);

class HeaderFeaturedCollection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.activeIndex = 1;
    this.numOfCards = this.querySelectorAll('.header-featured-collection__card').length;
    this.prevButton = this.querySelector('.header-featured-collection__prev-arrow');
    this.nextButton = this.querySelector('.header-featured-collection__next-arrow');
    this.bindedHandlePrevClick = this.handlePrevClick.bind(this);
    this.bindedHandleNextClick = this.handleNextClick.bind(this);

    this.prevButton?.addEventListener('click', this.bindedHandlePrevClick);
    this.nextButton?.addEventListener('click', this.bindedHandleNextClick);
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.bindedHandlePrevClick);
    this.nextButton?.removeEventListener('click', this.bindedHandleNextClick);
  }

  handlePrevClick() {
    if (this.activeIndex > 1) {
      this.nextButton.removeAttribute('disabled');
      this.activeIndex = this.activeIndex - 1;

      this.querySelector(`.header-featured-collection__card:nth-child(${this.activeIndex})`).scrollIntoView({ behavior: 'smooth', container: 'nearest', inline: 'start' });
    } else {
      this.prevButton.setAttribute('disabled', 'disabled');
    }
  }

  handleNextClick() {
    if (this.activeIndex < this.numOfCards - 3) {
      this.prevButton.removeAttribute('disabled');
      this.activeIndex = this.activeIndex + 1;

      this.querySelector(`.header-featured-collection__card:nth-child(${this.activeIndex})`).scrollIntoView({ behavior: 'smooth', container: 'nearest', inline: 'start' });
    } else {
      this.nextButton.setAttribute('disabled', 'disabled');
    }
  }
}

customElements.define('header-featured-collection', HeaderFeaturedCollection);
